import React from "react";
import { styled } from '@mui/material/styles';
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";

const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className, tooltip: 'custom-tooltip-inner' }} />
))(({ theme }) => ({
    '& .custom-tooltip-inner': {
        position: 'relative',
        backgroundColor: theme.palette.common.white,
        boxShadow: theme.shadows[1],
        color: theme.palette.common.black,
        fontSize: 16,
        maxWidth: 'none',
    },
}));

function CustomTooltip(props) {
    const { titleText, jsx, ...rest } = props;

    return (
        <StyledTooltip
            enterDelay={props.enterDelay ? props.enterDelay : 500}
            leaveDelay={props.leaveDelay ? props.leaveDelay : 250}
            {...rest}
            title={
                <React.Fragment>
                    {titleText}
                </React.Fragment>
            }
        />
    );
}

CustomTooltip.propTypes = {
    title: PropTypes.node
};

export default function CustomizedTooltips(props) {
    return (
        props.titleText === '' 
            ? props.jsx 
            : <CustomTooltip {...props} >
                {props.jsx}
            </CustomTooltip>
    );
}